import ResourcePage from "@/components/common/ResourcePage";

export default function PackagesPage() {
  return (
    <ResourcePage
      title="Packages" subtitle="Bundles of modules, features and industry packs"
      base="/v1/packages" perm="PACKAGE"
      columns={[
        { key: "packageCode", header: "Code", render: (r) => <span className="font-mono text-xs font-semibold">{r.packageCode}</span> },
        { key: "packageName", header: "Name" },
        { key: "moduleCodes", header: "Modules", render: (r) => (r.moduleCodes || []).length },
        { key: "mappedPlanCodes", header: "Mapped Plans", render: (r) => (r.mappedPlanCodes || []).join(", ") || "—" },
      ]}
      fields={[
        { name: "packageCode", label: "Package Code", immutable: true },
        { name: "packageName", label: "Package Name" },
        { name: "description", label: "Description" },
        { name: "moduleCodes", label: "Module Codes", type: "tags" },
        { name: "featureCodes", label: "Feature Codes", type: "tags" },
        { name: "industryPackCodes", label: "Industry Pack Codes", type: "tags" },
        { name: "mappedPlanCodes", label: "Mapped Plan Codes", type: "tags" },
      ]}
    />
  );
}
